import { createContext, useContext, useState, type ReactNode } from "react";

export type Currency = "GBP" | "USD";

export const CURRENCY_SYMBOL: Record<Currency, string> = { GBP: "£", USD: "$" };
export const CURRENCY_LABEL: Record<Currency, string> = { GBP: "£ GBP", USD: "$ USD" };

const STORAGE_KEY = "flat:currency";

type CurrencyCtx = {
  currency: Currency;
  symbol: string;
  setCurrency: (c: Currency) => void;
};

const Ctx = createContext<CurrencyCtx | null>(null);

export function CurrencyProvider({ children }: { children: ReactNode }) {
  const [currency, setCurrencyState] = useState<Currency>(
    () => (localStorage.getItem(STORAGE_KEY) as Currency | null) ?? "USD",
  );

  const setCurrency = (c: Currency) => {
    localStorage.setItem(STORAGE_KEY, c);
    setCurrencyState(c);
  };

  return (
    <Ctx.Provider value={{ currency, symbol: CURRENCY_SYMBOL[currency], setCurrency }}>
      {children}
    </Ctx.Provider>
  );
}

export function useCurrency(): CurrencyCtx {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useCurrency must be inside CurrencyProvider");
  return ctx;
}
